import { render, staticRenderFns } from "./alumniReport.vue?vue&type=template&id=64c4c586&scoped=true"
import script from "./alumniReport.vue?vue&type=script&lang=js"
export * from "./alumniReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4c586",
  null
  
)

export default component.exports